export default __webpack_public_path__ + "static/media/role-white.b021d182.svg";